import { Grid } from '@material-ui/core';
import { Button, StandardDialog } from '@roc/ui';
import { AppraisalDetailsV2Store } from 'libs/feature-documents/src/documents/stores/documentForms/appraisalDetailsV2/appraisalDetailsV2Store';
import { flowResult } from 'mobx';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import {
  AmountField,
  SelectOrdersField,
  SelectPropertiesField,
} from '../appraisalDetailsV2Fields';

export const ExtraPaymentLinkDialog = observer(
  ({
    store,
    open,
    onClose,
    onSuccess,
  }: {
    store: AppraisalDetailsV2Store;
    open: boolean;
    onClose: () => void;
    onSuccess?: (paymentLink: string) => void;
  }) => {
    const formStore = store.appraisalActionsStore.appraisalActionsFormStore;
    const selectedPropertyIds = formStore.form.fields.propertyIds.value;

    const orders = selectedPropertyIds
      .map(id => store.appraisalActionsStore.ordersByProperyId[id] || [])
      .flat();

    useEffect(() => {
      if (open) {
        store.appraisalActionsStore.reset();
        store.appraisalActionsStore.fetchPropertyValuations();
      }
    }, [open]);

    const dialogContent = (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <SelectPropertiesField
            properties={store.properties}
            fieldName="propertyIds"
            formStore={formStore}
          />
        </Grid>
        <Grid item xs={12}>
          <SelectOrdersField
            valuations={orders}
            fieldName="clientValuationReferenceIds"
            formStore={formStore}
          />
        </Grid>
        <Grid item xs={12}>
          <AmountField fieldName="amount" formStore={formStore} />
        </Grid>
      </Grid>
    );

    const dialogActions = (
      <>
        <Button
          testId="closeButton"
          variant="outlined"
          color="primary"
          onClick={onClose}
          style={{ marginRight: 8 }}
        >
          CLOSE
        </Button>
        <Button
          testId="submitButton"
          color="primary"
          variant="contained"
          onClick={async () => {
            const link = await flowResult(store.appraisalActionsStore.createExtraPaymentLink());
            if (link) {
              onClose();
              onSuccess?.(link);
            }
          }}
        >
          SUBMIT
        </Button>
      </>
    );

    return (
      <StandardDialog
        open={open}
        maxWidth="sm"
        title="Extra Payment Link"
        handleClose={onClose}
        dialogContent={dialogContent}
        dialogActions={dialogActions}
      />
    );
  }
);
